var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        _setup.Modal,
        {
          attrs: {
            title: "",
            "wrapper-class": "animate__animated",
            "modal-class": "room-modal",
            "in-class": "animate__zoomIn hideScroll",
            "out-class": "animate__zoomOut hideScroll",
          },
          model: {
            value: _setup.isModalShown,
            callback: function ($$v) {
              _setup.isModalShown = $$v
            },
            expression: "isModalShown",
          },
        },
        [
          _c(
            "div",
            { staticClass: "room-modal__header room-modal-header" },
            [
              _c(
                _setup.ModalTitle,
                {
                  staticClass: "room-modal-header__title",
                  on: {
                    close: function ($event) {
                      _setup.isModalShown = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_setup.props.title) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "discount-modal" }, [
            _c("div", { staticClass: "discount-modal__content" }, [
              _c(
                "div",
                { staticClass: "discount-modal__html" },
                [
                  !_setup.props.discountob.useList
                    ? [
                        _c(_setup.InsertHtml, {
                          staticClass: "html",
                          attrs: {
                            html: _setup.props.discountob.text,
                            link: "pdf",
                          },
                        }),
                      ]
                    : _c(
                        "div",
                        _vm._l(
                          _setup.props.discountob.list,
                          function ({ name }) {
                            return _c("div", [_vm._v(_vm._s(name))])
                          }
                        ),
                        0
                      ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _setup.props.discountob.useList
              ? _c("div", [_c(_setup.DiscountVdh)], 1)
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "discount" }, [
        _c("div", { staticClass: "discount__header" }, [
          _c("div", { staticClass: "discount__title" }, [
            _vm._v(_vm._s(_setup.props.title)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "discount__badge",
              class: { [_setup.props.iconClass]: _setup.props.iconClass },
            },
            [
              _c(_setup.icon_comp(_setup.props.icon), {
                tag: "component",
                staticClass: "discount__badge-icon",
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "discount__content" }, [
          _c(
            "div",
            { staticClass: "discount__html" },
            [
              !_setup.props.discountob.useList
                ? [
                    _c(_setup.InsertHtml, {
                      staticClass: "discount__hide",
                      attrs: {
                        html: _setup.props.discountob.text,
                        link: "pdf",
                      },
                    }),
                  ]
                : _c(
                    "div",
                    _vm._l(_setup.props.discountob.list, function ({ name }) {
                      return _c("div", [_vm._v(_vm._s(name))])
                    }),
                    0
                  ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "discount__link discount__open",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _setup.detail_click.apply(null, arguments)
              },
            },
          },
          [_vm._v("Подробная информация о скидках")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }